import { memo, useEffect, useState } from 'react'

import { IconName } from '../../Icon'
import { PageSectionSecondaryProps } from './PageSectionSecondaryProps'

import * as SC from './styles'

export const PageSectionSecondary = memo((props: PageSectionSecondaryProps) => {
  const {
    anchor,
    face,
    foldable = false,
    expanded = false,
    contentPaddings = true,
    title,
    actions,
    children,
    onToggle
  } = props

  const [isExpanded, setIsExpanded] = useState(expanded)

  useEffect(() => {
    setIsExpanded(expanded)
  }, [expanded])

  const handleHeaderClick = () => {
    if (foldable) {
      const newExpandedFlag = !isExpanded
      setIsExpanded(newExpandedFlag)
      if (onToggle) {
        onToggle(newExpandedFlag)
      }
    }
  }

  const handleActionsClick = (e) => {
    e.stopPropagation()
    e.preventDefault()
  }

  const isShowContent = (foldable && isExpanded) || !foldable

  return (
    <SC.Section id={anchor} $face={face}>
      {face === 'solid' && (
        <>
          <SC.HeaderSolid onClick={handleHeaderClick} $foldable={foldable} $expanded={isExpanded}>
            <SC.TitleWrap>
              {foldable && <SC.ToggleIcon name={isExpanded ? IconName.EXPAND_LESS : IconName.EXPAND_MORE} />}
              {title}
            </SC.TitleWrap>
            <SC.Actions onClick={handleActionsClick}>{actions}</SC.Actions>
          </SC.HeaderSolid>
          {isShowContent && <SC.Content $hasPaddings={contentPaddings}>{children}</SC.Content>}
        </>
      )}

      {face === 'outlined' && (
        <>
          <SC.HeaderOutlined onClick={handleHeaderClick} $foldable={foldable} $expanded={isExpanded}>
            <SC.TitleWrap>
              {foldable && <SC.ToggleIcon name={isExpanded ? IconName.EXPAND_LESS : IconName.EXPAND_MORE} />}
              {title}
            </SC.TitleWrap>
            <SC.Actions onClick={handleActionsClick}>{actions}</SC.Actions>
          </SC.HeaderOutlined>
          {isShowContent && <SC.Content $hasPaddings={contentPaddings}>{children}</SC.Content>}
        </>
      )}
    </SC.Section>
  )
})
